import React, {useState} from 'react';

function BusinessWeekScheduler() {
    const daysOfWeek = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
    const [checkedDays, setCheckedDays] = useState([]);
    const [times, setTimes] = useState({});
    const [specificTimes, setSpecificTimes] = useState([{ fromDate: '', toDate: '', fromTime: '', toTime: '' }]);
    const [blockedTimes, setBlockedTimes] = useState([{ fromDate: '', toDate: '', fromTime: '', toTime: '' }]);

    const handleCheckboxChange = (day) => {
        setCheckedDays(prevCheckedDays =>
            prevCheckedDays.includes(day)
                ? prevCheckedDays.filter(d => d !== day)
                : [...prevCheckedDays, day]
        );
        if (!times[day]) {
            setTimes(prevTimes => ({
                ...prevTimes,
                [day]: [{ from: '', to: '' }]
            }));
        }
    };

    const handleTimeChange = (day, index, type, value) => {
        setTimes(prevTimes => ({
            ...prevTimes,
            [day]: prevTimes[day].map((time, i) => (
                i === index ? { ...time, [type]: value } : time
            ))
        }));
    };

    const addTimeRange = (day) => {
        setTimes(prevTimes => ({
            ...prevTimes,
            [day]: [...prevTimes[day], { from: '', to: '' }]
        }));
    };

    const removeTimeRange = (day, index) => {
        setTimes(prevTimes => ({
            ...prevTimes,
            [day]: prevTimes[day].filter((_, i) => i !== index)
        }));
    };

    const handleSpecificTimeChange = (index, type, value) => {
        setSpecificTimes(prevSpecificTimes =>
            prevSpecificTimes.map((specificTime, i) =>
                i === index ? { ...specificTime, [type]: value } : specificTime
            )
        );
    };

    const addSpecificTimeRange = () => {
        setSpecificTimes(prevSpecificTimes => [
            ...prevSpecificTimes,
            { fromDate: '', toDate: '', fromTime: '', toTime: '' }
        ]);
    };

    const removeSpecificTimeRange = (index) => {
        setSpecificTimes(prevSpecificTimes => prevSpecificTimes.filter((_, i) => i !== index));
    };

    const handleBlockedTimeChange = (index, type, value) => {
        setBlockedTimes(prevBlockedTimes =>
            prevBlockedTimes.map((blockedTime, i) =>
                i === index ? { ...blockedTime, [type]: value } : blockedTime
            )
        );
    };

    const addBlockedTimeRange = () => {
        setBlockedTimes(prevBlockedTimes => [
            ...prevBlockedTimes,
            { fromDate: '', toDate: '', fromTime: '', toTime: '' }
        ]);
    };

    const removeBlockedTimeRange = (index) => {
        setBlockedTimes(prevBlockedTimes => prevBlockedTimes.filter((_, i) => i !== index));
    };

    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minutes = 0; minutes < 60; minutes += 5) {
                const timeString = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                options.push(<option key={timeString} value={timeString}>{timeString}</option>);
            }
        }
        return options;
    };

    return (
        <div className="WeekScheduler flex">
            <div className={'week-time-container'}>
                <div className={'week-times-title-container'}>
                    <h3>ימים ושעות פעילות העסק</h3>
                    <div className={'flex'}>
                    <select className={'area-container'}>
                        <option>כל האזורים</option>
                        <option>קפה - הכל</option>
                        <option>פאב - הכל</option>
                    </select>
                    <button type="button" className="save-range-button">שמור</button>
                    </div>
                </div>
                <form className="days-form">
                    {daysOfWeek.map((day, index) => (
                        <div key={index} className="day-container">
                        <div className="day-container-and-time">
                            <label className="day-label">
                                <input
                                    type="checkbox"
                                    value={day}
                                    checked={checkedDays.includes(day)}
                                    onChange={() => handleCheckboxChange(day)}
                                />
                                {day}
                            </label>
                            <button type="button" className="add-time-range-button" onClick={() => addTimeRange(day)}>+</button>
                        </div>
                        {checkedDays.includes(day) && (
                            <div>
                                {times[day].map((timeRange, i) => (
                                    <div key={i} className="select-container">
                                        <label>
                                            משעה:
                                            <select
                                                value={timeRange.from}
                                                onChange={(e) => handleTimeChange(day, i, 'from', e.target.value)}
                                            >
                                                {generateTimeOptions()}
                                            </select>
                                        </label>
                                        <label>
                                            עד שעה:
                                            <select
                                                value={timeRange.to}
                                                onChange={(e) => handleTimeChange(day, i, 'to', e.target.value)}
                                            >
                                                {generateTimeOptions()}
                                            </select>
                                        </label>
                                        {i > 0 && (
                                            <button
                                                type="button"
                                                className="remove-time-range-button"
                                                onClick={() => removeTimeRange(day, i)}
                                            >
                                                -
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </form>

            </div>
                <div className={'flex special-events'}>
                    <div className="specific-time-container">
                        <div className={'specieal-event-title'}>
                            <h3>פתוח פעילות חריגה</h3>
                            <button type="button" className="add-time-range-button" onClick={addSpecificTimeRange}>+</button>
                        </div>
                        {specificTimes.map((specificTime, index) => (
                            <div key={index} className="specific-time-range">
                                <label>
                                     מתאריך:
                                    <input
                                        type="date"
                                        value={specificTime.fromDate}
                                        onChange={(e) => handleSpecificTimeChange(index, 'fromDate', e.target.value)}
                                    />
                                </label>
                                <label>
                                    עד תאריך:
                                    <input
                                        type="date"
                                        value={specificTime.toDate}
                                        onChange={(e) => handleSpecificTimeChange(index, 'toDate', e.target.value)}
                                    />
                                </label>
                                <label>
                                    משעה:
                                    <select
                                        value={specificTime.fromTime}
                                        onChange={(e) => handleSpecificTimeChange(index, 'fromTime', e.target.value)}
                                    >
                                        {generateTimeOptions()}
                                    </select>
                                </label>
                                <label>
                                    עד שעה:
                                    <select
                                        value={specificTime.toTime}
                                        onChange={(e) => handleSpecificTimeChange(index, 'toTime', e.target.value)}
                                    >
                                        {generateTimeOptions()}
                                    </select>
                                </label>
                                {index > 0 && (
                                    <button
                                        type="button"
                                        className="remove-time-range-button"
                                        onClick={() => removeSpecificTimeRange(index)}
                                    >
                                        -
                                    </button>
                                )}
                            </div>
                        ))}

                    </div>
                    <div className="blocked-time-container">
                        <div className={'specieal-event-title'}>
                            <h3>חסום שעות פעילות</h3>
                            <button type="button" className="add-time-range-button" onClick={addBlockedTimeRange}>+</button>
                        </div>
                        {blockedTimes.map((blockedTime, index) => (
                            <div key={index} className="specific-time-range">
                                <label>
                                    מתאריך:
                                    <input
                                        type="date"
                                        value={blockedTime.fromDate}
                                        onChange={(e) => handleBlockedTimeChange(index, 'fromDate', e.target.value)}
                                    />
                                </label>
                                <label>
                                    עד תאריך:
                                    <input
                                        type="date"
                                        value={blockedTime.toDate}
                                        onChange={(e) => handleBlockedTimeChange(index, 'toDate', e.target.value)}
                                    />
                                </label>
                                <label>
                                    משעה:
                                    <select
                                        value={blockedTime.fromTime}
                                        onChange={(e) => handleBlockedTimeChange(index, 'fromTime', e.target.value)}
                                    >
                                        {generateTimeOptions()}
                                    </select>
                                </label>
                                <label>
                                    עד שעה:
                                    <select
                                        value={blockedTime.toTime}
                                        onChange={(e) => handleBlockedTimeChange(index, 'toTime', e.target.value)}
                                    >
                                        {generateTimeOptions()}
                                    </select>
                                </label>
                                {index > 0 && (
                                    <button
                                        type="button"
                                        className="remove-time-range-button"
                                        onClick={() => removeBlockedTimeRange(index)}
                                    >
                                        -
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
        </div>
    );
}
export default BusinessWeekScheduler;